const SERVICE_LEVEL_OPTIONS = [
  { value: 0, label: "Read Only (View menu only)" },
  { value: 1, label: "Call Waiter Only (No basket)" },
  { value: 2, label: "Basket + Call Waiter" },
  { value: 3, label: "Full Ordering" },
];

export const REPORT_MENU_ITEMS = [
  {
    id: "Orders",
    label: "Orders",
    icon: "ri-file-chart-line",
    link: "/report/orders",
    badgeName: "(Daily Stats)",
    parentId: "Reports",
    permission: "order",
  },
  {
    id: "Menu Item",
    label: "Menu Item",
    icon: "ri-restaurant-line",
    link: "/report/menu-item",
    parentId: "Reports",
    permission: "order",
  },
  {
    id: "Service Station",
    label: "Service Stations",
    icon: "ri-ticket-2-line",
    link: "/report/service-station",
    parentId: "Reports",
    permission: "service_station_report",
  },
  {
    id: "Delivery Time",
    label: "Delivery Time",
    icon: "ri-ticket-2-line",
    link: "/report/delivery-time",
    parentId: "Reports",
    permission: "delivery_time_report",
  },
  {
    id: "Feedback",
    label: "Feedback",
    icon: "ri-feedback-line",
    link: "/feedback",
    parentId: "Reports",
    permission: "feedback",
  },
];

export const getMaxServiceLevel = (usage) => usage?.limits?.max_service_level ?? 0;

export const canFullOrder = (usage) => getMaxServiceLevel(usage) >= 3;

export const getServiceLevelOptions = (maxLevel) =>
  SERVICE_LEVEL_OPTIONS.filter((o) => o.value <= maxLevel);

export const getDefaultServiceLevel = (usage) => Math.min(3, getMaxServiceLevel(usage));

export const hasActiveSubscription = (user) => user?.hasActiveSubscription === true;

export const normalizePermissions = (permission) => {
  if (!permission) return null;
  const { permission_id, user_id, ...perms } = permission;
  return perms;
};

export const canShowReportItem = (isRoot, permissions, permissionKey, activeSubscription) => {
  if (isRoot) return true;
  // Temporarily disable active subscription gating for report menu items.
  // if (activeSubscription !== true) return false;
  return Number(permissions?.[permissionKey] ?? 0) >= 1;
};
